<header
  #navBarStrip
  class="header d-flex align-items-center"
  [style.width]="navChatDockMargin ? 'calc(100% - ' + navChatDockMargin + 'px)' : null"
>
  <div class="container">
    <div class="row">
      <div class="d-flex justify-content-between align-items-center">
        <div
          class="header__heading d-flex justify-content-center align-items-center pe-none text-xs text-md-sm"
          title="Government Of India"
        >
          <img
            width="33"
            height="23"
            fetchpriority="high"
            src="images/indian-flag.svg"
            alt="Indian Flag"
          />
          <div class="header__heading_content">Government Of India</div>
        </div>
        <div class="header__accessibility d-flex align-items-center">
          <div
            class="header_font_container d-flex justify-content-center align-items-center"
          >
            <div
              class="d-flex align-items-center justify-content-center font font--small cursor-pointer"
              [ngClass]="{
                selected: currentFontSize === accessibiltyFontSizes.small
              }"
              (click)="onFontSizeSelect(accessibiltyFontSizes.small)"
              title="Small"
            >
              <span>A</span><span>-</span>
            </div>
            <div
              class="d-flex align-items-center justify-content-center font font--normal cursor-pointer"
              [ngClass]="{
                selected: currentFontSize === accessibiltyFontSizes.normal
              }"
              (click)="onFontSizeSelect(accessibiltyFontSizes.normal)"
              title="Normal"
            >
              A
            </div>
            <div
              class="d-flex align-items-center justify-content-center font font--large cursor-pointer"
              [ngClass]="{
                selected: currentFontSize === accessibiltyFontSizes.large
              }"
              (click)="onFontSizeSelect(accessibiltyFontSizes.large)"
              title="Large"
            >
              <span>A</span><span>+</span>
            </div>
          </div>
          <div class="vetical-line"></div>
          <div
            class="header__accessibility_options d-flex justify-content-center align-items-center cursor-pointer text-xs text-md-sm"
            title="Accessibility"
          >
            <!-- accessibility panel -->
             @if(renderAccesibilityContent){
              <div class="widget-overlay-wrapper">
            <div
              class="uwaw uw-light-theme gradient-head uwaw-initial paid_widget"
              id="uw-main"
              [ngClass]="isAccessibilityOpen ? 'visible' : 'hidden'"
            >
              <div class="relative second-panel bg-primary">
                <h3>Accessibility options by UX4G</h3>
                <div class="uwaw-close" onclick="closeMain()"></div>
              </div>
              <div class="uwaw-body">
                <div class="h-scroll">
                  <div class="uwaw-features">
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem_sp"
                    >
                      <button
                        id="speak"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-speaker"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Text To Speech</span
                        >
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon_sp"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem"
                    >
                      <button
                        id="btn-s9"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-bigger-text">
                          </span> </span
                        ><span class="uwaw-features__item__name"
                          >Bigger Text</span
                        >
                        <div
                          class="uwaw-features__item__steps reset-steps"
                          id="featureSteps"
                        >
                          <!-- Steps span tags will be dynamically added here -->
                        </div>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-st"
                    >
                      <button
                        id="btn-small-text"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-small-text">
                          </span> </span
                        ><span class="uwaw-features__item__name"
                          >Small Text</span
                        >
                        <div
                          class="uwaw-features__item__steps reset-steps"
                          id="featureSteps-st"
                        >
                          <!-- Steps span tags will be dynamically added here -->
                        </div>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-st"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-lh"
                    >
                      <button
                        id="btn-s12"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-line-hight"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Line Height</span
                        >
                        <div
                          class="uwaw-features__item__steps reset-steps"
                          id="featureSteps-lh"
                        >
                          <!-- Steps span tags will be dynamically added here -->
                        </div>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-lh"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-ht"
                    >
                      <button
                        id="btn-s10"
                        onclick="highlightLinks()"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-highlight-links"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Highlight Links</span
                        >
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-ht"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-ts"
                    >
                      <button
                        id="btn-s13"
                        onclick="increaseAndReset()"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-text-spacing"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Text Spacing</span
                        >
                        <div
                          class="uwaw-features__item__steps reset-steps"
                          id="featureSteps-ts"
                        >
                          <!-- Steps span tags will be dynamically added here -->
                        </div>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-ts"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-df"
                    >
                      <button
                        id="btn-df"
                        onclick="toggleFontFeature()"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-dyslexia-font"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Dyslexia Friendly</span
                        >
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-df"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-hi"
                    >
                      <button
                        id="btn-s11"
                        onclick="toggleImages()"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-hide-images"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Hide Images</span
                        >
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-hi"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-Cursor"
                    >
                      <button
                        id="btn-cursor"
                        onclick="toggleCursorFeature()"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-cursor"> </span>
                        </span>
                        <span class="uwaw-features__item__name">Cursor</span>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-cursor"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-ht-dark"
                    >
                      <button
                        id="dark-btn"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__name">
                          <span class="light_dark_icon">
                            <input
                              type="checkbox"
                              class="light_mode uwaw-featugres__item__i"
                              id="checkbox"
                            />
                            <label for="checkbox" class="checkbox-label">
                              <!-- <i class="fas fa-moon-stars"></i> -->
                              @if(isBrowser){
                                <i class="fas fa-moon-stars">
                                  <span class="ux4g-icon icon-moon"></span>
                                </i>
                                <i class="fas fa-sun">
                                  <span class="ux4g-icon icon-sun"></span>
                                </i>
                              }
                              <span class="ball"></span>
                            </label>
                          </span>
                          <span class="uwaw-features__item__name"
                            >Light-Dark</span
                          >
                        </span>
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-ht-dark"
                          style="display: none; pointer-events: none"
                        >
                        </span>
                      </button>
                    </div>
                    <!-- Invert Colors Widget -->
                    <div
                      class="uwaw-features__item reset-feature"
                      id="featureItem-ic"
                    >
                      <button
                        id="btn-invert"
                        class="uwaw-features__item__i"
                        data-uw-reader-content="Enable the UserWay screen reader"
                        aria-label="Enable the UserWay screen reader"
                        aria-pressed="false"
                      >
                        <span class="uwaw-features__item__icon">
                          <span class="ux4g-icon icon-invert"> </span>
                        </span>
                        <span class="uwaw-features__item__name"
                          >Invert Colors</span
                        >
                        <span
                          class="tick-active uwaw-features__item__enabled reset-tick"
                          id="tickIcon-ic"
                          style="display: none"
                        >
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Reset Button -->
              </div>
              <div class="reset-panel">
                <!-- copyright accessibility bar -->
                <div class="copyrights-accessibility">
                  <button
                    class="btn-reset-all"
                    id="reset-all"
                    onclick="resetAll()"
                  >
                    <span class="reset-icon"> </span>
                    <span class="reset-btn-text">Reset All Settings</span>
                  </button>
                  <a
                    href="https://www.ux4g.gov.in"
                    target="_blank"
                    class="copyright-text"
                    contenteditable="false"
                    style="cursor: pointer"
                  >
                    <span
                      class="uwaw-features__item__name ux4g-copy ux4g-copyright"
                      >Created by</span
                    >
                    <img
                      fetchpriority="high"
                      src="https://www.ux4g.gov.in/assets/img/logo/ux4g-logo.svg"
                      alt="UX4G"
                    />
                  </a>
                </div>
              </div>
            </div>
            </div>
          }
            <button
              id="uw-widget-custom-trigger"
              class="cursor-pointer d-flex align-items-center p-0 border-0 bg-black text-white gap-2"
              aria-label="Accessibility Widget"
              data-uw-trigger="true"
              aria-haspopup="dialog"
              title="Accessibility Option"
              onclick="openMain()"
              (click)="onAccessibilityClick()"
            >
              <img
                fetchpriority="high"
                width="18"
                height="18"
                src="images/accessibility.svg"
                alt="Accessibility"
              /><span class="text-sm">Accessibility Options</span></button
            ><!-- accessibility panel end-->
            <!--  language Dropdown selector -->
           <div>
            <app-bhashini-language-translation></app-bhashini-language-translation>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
